import { page_builder_origin } from "features/PageBuilders/PageBuilders.constants";
import { appendUrlParams } from "utils/urlUtils";

export const GJS_HOMEPAGE_BUILDER_ROUTE_KEYS = {
  update: "gjs-homepage-builder-update",
  storefront_homepage: "storefront-homepage",
};

export const GJS_HOMEPAGE_BUILDER_ROUTE_IDS = {
  [GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.update]:
    "/gjs-homepage-builder/:homepageUuid/update",
  [GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.storefront_homepage]: "/StorefrontHomepage",
};

export const GJS_HOMEPAGE_BUILDER_ROUTE_GENERATORS = {
  [GJS_HOMEPAGE_BUILDER_ROUTE_KEYS.update]: ({
    homepageUuid,
    templateUuid,
  }) => {
    const params = {};
    if (templateUuid) {
      params.template = templateUuid;
    }
    return appendUrlParams(
      `/gjs-homepage-builder/${homepageUuid}/update`,
      params
    );
  },
};

export const HOMEPAGE_PAGE_BUILDER_SOURCE = {
  EXLY_BUILDER: 1,
  GRAPE_JS: 2,
};

export const hp_action_keys = {
  listener_added: "hp-listener-added",
  start_init: "hp-start-init",
  save: "hp-save",
  save_draft: "hp-save-draft",
  auto_save: "hp-auto-save",
  publish: "hp-publish",
  upload_images: "hp-upload-images",
  image_uploaded: "hp-image-uploaded",
  media_library: {
    fetch_all: "hp-media-library-fetch-all",
    fetched: "hp-media-library-fetched",
    get_preview_url: "hp-get-preview-url",
    on_get_preview_url: "hp-on-get-preview-url",
  },
  notify: "hp-notify",
  // sent by the builder's back button - parent navigates to the app dashboard
  exit_builder: "hp-exit-builder",
  // the shared GJS sidebar top (sales page builder plugin) posts the unprefixed action
  exit_builder_legacy: "exit-builder",
  change_template: "hp-change-template",
  open_settings: "hp-open-settings",
  fetch_template: "hp-fetch-template-html",
  template_fetched: "hp-template-html-fetched",
  offering_card_select_open: "offering-card-select-open", // page builder asks CT to open the offering picker modal
  offering_card_select_save: "offering-card-select-save", // CT posts the picked offering back to the page builder
  rating_setting_get: "rating-setting-get", // page builder asks CT to read the account-level show_listing_ratings setting
  rating_setting_value: "rating-setting-value", // CT posts the setting value back to the page builder
  rating_setting_update: "rating-setting-update", // page builder asks CT to persist the account-level show_listing_ratings setting
  rating_setting_updated: "rating-setting-updated", // CT confirms the setting write back to the page builder
};

export const homepage_builder_url = `${page_builder_origin}/homepage`;

// Hash route for the "Settings" (customizations) view of TemplatePreview
export const homepage_settings_route_path = "/TemplatePreview";

// Query params used to deep-link into the settings view and select the builder mode
export const homepage_url_query_params = {
  tab: "tab",
  builder: "builder",
};

export const homepage_builder_mode_values = {
  advanced: "advanced",
};

export const HOMEPAGE_API_PREFIX = "marketing/homepage";

export const homepage_apis = {
  create_homepage: `${HOMEPAGE_API_PREFIX}/create`,
  get_active_homepage: `${HOMEPAGE_API_PREFIX}/active-detail`,
  get_homepage_detail: (homepageUuid) =>
    `${HOMEPAGE_API_PREFIX}/detail/${homepageUuid}`,
  update_homepage: (homepageUuid) =>
    `${HOMEPAGE_API_PREFIX}/detail/${homepageUuid}`,
  publish_homepage: (homepageUuid) =>
    `${HOMEPAGE_API_PREFIX}/publish/${homepageUuid}`,
  get_homepage_template: (homepageUuid) =>
    `${HOMEPAGE_API_PREFIX}/template/${homepageUuid}`,
};
